<template>
  <div>
    <div class="banner-sec">
      <div class="banner banner-aboutus">
        <div class="wd1">
          <h2 class="banner-title-main">关于我们</h2>
        </div>
      </div>
    </div>
    <div id="about" class="sec sec-aboutus cp-backcolor">
      <div class="wd">
        <div style="width: 90%;margin: 0 auto">
          <h2 class="g-h3-title">企业介绍</h2>
          <p>
            北京天行数科数据科技有限公司（简称“北京天行数科”）成立于2015年11月28日。公司专注于为银行、保险、汽车金融、消费金融、融资租赁、保理等领域提供定制化数据产品，帮助合作机构丰富数据来源、提升风险控制水平、降低经营成本。</p>
          <p>北京天行数科已与政府单位以及公司建立合作，目前可提供几十种风控数据产品。合作机构数百家，涵盖20个地区。</p>
          <p>本着数据多元化、价值最大化的战略方向，争取成为数据驱动金融的有力推动者。未来将不断丰富数据源，推出基于不同业务场景所需要的定制化数据产品。</p>
        </div>
      </div>
    </div>


    <div id="qualification" class="cp-one-2 cp-backcolor">
      <div class="wd">
        <div style="width: 90%;margin: 0 auto">
          <h2 class="g-h3-title">企业资质</h2>
          <div class="grid-wrap staff-list clearfix" style="text-align: center">
            <div class="grid grid-3">
              <img src="../assets/images/qualification.png">
              <p style="padding: 10px 0;font-size: 18px;font-weight: 600">信息系统安全等级保护第3级备案证明</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div id="culture" class="cp-one-2 cp-backcolor">
      <div class="wd">
        <div style="width: 90%;margin: 0 auto">
          <h2 class="g-h3-title">企业风采</h2>
          <div class="grid-wrap staff-list clearfix" style="text-align: center">
            <div class="grid grid-3">
              <img src="../assets/images/culture1.png">
              <!-- <p style="padding: 10px 0;font-size: 18px;font-weight: 600">公司前台</p>-->
            </div>
            <div class="grid grid-3">
              <img src="../assets/images/culture3.png">
              <!--<p style="padding: 10px 0;font-size: 18px;font-weight: 600">公司活动</p>-->
            </div>
            <div class="grid grid-3">
              <img src="../assets/images/cultrue1.jpg">
              <!--<p style="padding: 10px 0;font-size: 18px;font-weight: 600">公司活动</p>-->
            </div>
            <!--<div class="grid grid-3">
              <img src="../assets/images/culture2.png">
              &lt;!&ndash;<p style="padding: 10px 0;font-size: 18px;font-weight: 600">公司活动</p>&ndash;&gt;
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="culture-menu culture-menu-fix">
      <a @click="goAnchor('#about')" href="javascript:void(0)" :class="{'culture-menu-active': aboutActive == true}">企业介绍</a>
      <a @click="goAnchor('#qualification')" href="javascript:void(0)" :class="{'culture-menu-active': qualificationActive == true}">企业资质</a>
      <a @click="goAnchor('#culture')" href="javascript:void(0)" :class="{'culture-menu-active': cultureActive == true}">企业风采</a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'HelloWorld',
    data() {
      return {
        aboutActive: true,
        qualificationActive: false,
        cultureActive: false,
      }
    },
    mounted: function () {
      let that = this;
      window.onscroll = function () {
        var t = document.documentElement.scrollTop || document.body.scrollTop;  //获取距离页面顶部的距离
       // console.log(t)
       //alert(t);
        if (t < 520) {
          that.aboutActive = true;
          that.qualification = false;
          that.cultureActive = false;
        } else if (t > 520 && t < 610) {
          that.aboutActive = false;
          that.qualification = true;
          that.cultureActive = false;
        } else {
          that.aboutActive = false;
          that.qualification = false;
          that.cultureActive = true;
        }
      }
    },
    methods: {
      goAnchor(selector) {
        let that = this;
        let anchor = this.$el.querySelector(selector);
        /*document.documentElement.scrollTop = anchor.offsetTop;*/
        let total = 0;
        if (selector == '#about') {
          total = anchor.offsetTop - 69;
          that.toAbout();
        } else if (selector == '#qualification') {
          total = anchor.offsetTop-69;
          that.toQualification();
        } else {
          total = anchor.offsetTop;
          that.toCulture();
        }
        let distance = document.documentElement.scrollTop || document.body.scrollTop;
        // 平滑滚动，时长500ms，每10ms一跳，共50跳
        let step = total / 50;
        if (total > distance) {
          smoothDown()
        } else {
          let newTotal = distance - total;
          step = newTotal / 50;
          smoothUp();
        }

        function smoothDown() {
          if (distance < total) {
            distance += step;
            document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance;
            setTimeout(smoothDown, 10)
          } else {
            document.body.scrollTop = total;
            document.documentElement.scrollTop = total;
          }
        }

        function smoothUp() {
          if (distance > total) {
            distance -= step;
            document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance;
            setTimeout(smoothUp, 10)
          } else {
            document.body.scrollTop = total;
            document.documentElement.scrollTop = total
          }
        }

      },
      toAbout() {
        let that = this;
        that.aboutActive = true;
        that.qualificationActive = false;
        that.cultureActive = false;
      },
      toQualification() {
        let that = this;
        that.aboutActive = false;
        that.qualificationActive = true;
        that.cultureActive = false;
      },
      toCulture() {
        let that = this;
        that.aboutActive = false;
        that.qualificationActive = false;
        that.cultureActive = true;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/About.vue